// Kept in a separate file (without "use client") so both server
// and client components can safely import it.
export const SECONDARY_NAV_ID = "secondaryNav";
export const STICKY_NAV_ID = "stickyNav";
